<!--Header-->
<div class="notification-header">
    <span>Notifications</span>
</div>

<!--Blue Bar-->
<div class="notification-info">
    <span>{{numberOfNewNotifications}} notifications unread</span>
    <i class="fas fa-check-double cursor-pointer" data-placement="top"
       ngbTooltip="Mark all as read" (click)="markAllAsRead()"></i>
</div>

<!--Notification List-->
<div class="notification-content blue-scroll-bar"
     infiniteScroll
     [infiniteScrollDistance]="1"
     [infiniteScrollThrottle]="150"
     [scrollWindow]="false"
     (scrolled)="onScroll()">


    <div class="item-element" *ngFor="let notification of unreadNotifications">

        <a (click)="markOneAsRead(notification.id)" class="item-link"
           [routerLink]="notification.type === 'leaveRequest' ? 'days-off/view/' + notification.link :
                         notification.type === 'ticket' ? 'tickets/view/' + notification.link :
                         notification.type === 'procedure' ? 'procedures/' + notification.link :
                         notification.type === 'directive' ? 'directives/' + notification.link :
                         notification.type === 'project' ? 'projects/' + notification.link : ''">

            <i class="fas item-icon"
               [ngClass]="notification.category === 'HR' ? 'fa-chart-pie' :
                          notification.category === 'CRM' ? 'fa-users' :
                          notification.category === 'ERP' ? 'fa-headset' :
                          notification.category === 'user' ? 'fa-info-circle' : ''"></i>

            <span class="link-content">

                <span class="name">
                   {{notification.title}}
                </span>

                <span class="date">
                    {{notification.createdAt}}
                </span>
            </span>
        </a>

        <div class="mark-as-read">
            <i class="fas fa-check" data-placement="top"
               ngbTooltip="Mark as read" (click)="markOneAsRead(notification.id)"></i>
        </div>
    </div>


</div>

<div class="no-notifications" *ngIf="unreadNotifications.length === 0">
    <span>There are no notifications at the moment.</span>
</div>

<!--View All-->
<div class="see-all-notifications">
    <a routerLink="notifications/">See all notifications</a>
</div>
